import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { css, jsx } from '@emotion/react';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { messages } from '../../../../../../messages';
import AIIcon from '../../../../../common/ai-icon';
import AIIndicatorTooltip from './ai-indicator-tooltip';
import AIIndicatorContainer from './ai-indicator-container';
import AILearnMoreAnchor from '../../../common/ai-summary/ai-learn-more-anchor';
const tooltipMsgStyles = xcss({
  color: 'color.text',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px'
});
const iconTooltipLinkStyles = css({
  color: "var(--ds-text-subtlest, #626F86)",
  '&:link, :visited': {
    color: "var(--ds-text-subtlest, #626F86)"
  },
  '&:hover': {
    color: "var(--ds-text-subtle, #44546F)"
  },
  '&:active': {
    color: "var(--ds-text, #172B4D)"
  },
  textDecoration: 'underline'
});
const iconTooltipTitleStyles = xcss({
  color: 'color.text',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px'
});
const iconTooltipDescStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '11px',
  fontWeight: '400',
  lineHeight: '14px'
});
const iconTooltipTriggerStyles = xcss({
  verticalAlign: 'bottom'
});
const AIStateDone = ({
  appearance,
  testId
}) => {
  const icon = jsx(AIIcon, {
    label: "AI",
    size: "small",
    testId: `${testId}-done-icon`
  });
  const title = getBooleanFF('platform.linking-platform.smart-card.hover-card-ai-summaries-release-stable') ? jsx(Box, {
    testId: `${testId}-done-message`
  }, jsx(FormattedMessage, messages.ai_summarized)) : jsx(React.Fragment, null, jsx(Box, {
    testId: `${testId}-done-message`
  }, jsx(FormattedMessage, messages.ai_summarized_abbreviation)), jsx(Box, null, jsx(Lozenge, {
    appearance: "new",
    testId: `${testId}-beta`
  }, jsx(FormattedMessage, messages.beta))));
  switch (appearance) {
    case 'icon-only':
      return jsx(AIIndicatorTooltip, {
        content: jsx(Inline, {
          alignBlock: "center",
          space: "space.100"
        }, jsx(AIIcon, {
          label: "AI",
          size: "medium",
          testId: `${testId}-done-tooltip-icon`
        }), jsx(Stack, null, jsx(Inline, {
          alignBlock: "center",
          alignInline: "start",
          space: "space.050",
          xcss: iconTooltipTitleStyles
        }, title), jsx(Box, {
          xcss: iconTooltipDescStyles
        }, jsx(FormattedMessage, _extends({}, messages.ai_summarized_info, {
          values: {
            a: chunks => jsx(AILearnMoreAnchor, {
              css: iconTooltipLinkStyles
            }, chunks)
          }
        }))))),
        trigger: icon,
        xcss: iconTooltipTriggerStyles
      });
    default:
      return jsx(AIIndicatorContainer, {
        icon: icon,
        content: jsx(Inline, {
          alignBlock: "center",
          alignInline: "start",
          space: "space.050"
        }, title, jsx(AIIndicatorTooltip, {
          content: jsx(Box, {
            xcss: tooltipMsgStyles,
            testId: `${testId}-done-tooltip`
          }, jsx(FormattedMessage, _extends({}, messages.ai_summarized_info, {
            values: {
              a: chunks => jsx(AILearnMoreAnchor, null, chunks)
            }
          }))),
          trigger: jsx(EditorPanelIcon, {
            label: "Info",
            size: "small",
            testId: `${testId}-done-info`
          })
        })),
        testId: `${testId}-done`
      });
  }
};
export default AIStateDone;